<template>
    <button id="PAGE_UP" name="PAGE_UP" class="btn" data-vcode="PAGE_UP">
        <img src="/images/icons/pageUp.svg" alt="" role="img" aria-hidden="true" />
        <label>{{ $t('pageUp') }}</label>
    </button>
</template>
<script>
export default {};
</script>
